import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import { RequireAuth } from './AuthGuards';

// render- Dashboard
const DashboardPage = Loadable(lazy(() => import('pages/dashboard/dashboard')));
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const AppointmentsPage = Loadable(lazy(() => import('pages/inicio/atendimentos')));
const CalendarPage = Loadable(lazy(() => import('pages/inicio/calendario')));
const FinancialPage = Loadable(lazy(() => import('pages/financeiro/financeiro')));
const LivroCaixaPage = Loadable(lazy(() => import('pages/financeiro/livro-caixa')));
const ComprasPage = Loadable(lazy(() => import('pages/financeiro/compras')));
const SimuladorPage = Loadable(lazy(() => import('pages/financeiro/simulador')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - intellivitta
const AgendamentosPage = Loadable(lazy(() => import('pages/intellivitta/agendamentos')));
const BodyMapPage = Loadable(lazy(() => import('pages/intellivitta/mapa-corporal')));

// render - cadastros
const PatientsPage = Loadable(lazy(() => import('pages/cadastros/pacientes')));
const PatientDetailPage = Loadable(lazy(() => import('pages/cadastros/paciente')));
const BirthdaysPage = Loadable(lazy(() => import('pages/cadastros/aniversariantes')));
const ProfessionalsPage = Loadable(lazy(() => import('pages/cadastros/profissionais')));
const ProceduresPage = Loadable(lazy(() => import('pages/cadastros/procedimentos')));
const PlansPage = Loadable(lazy(() => import('pages/cadastros/planos')));
const AnamnesisPage = Loadable(lazy(() => import('pages/cadastros/anamnese')));
const PricingPage = Loadable(lazy(() => import('pages/cadastros/precificacao')));
const MensageriaPage = Loadable(lazy(() => import('pages/cadastros/mensageria')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <RequireAuth>
      <DashboardLayout />
    </RequireAuth>
  ),
  children: [
    {
      path: '/',
      element: <Navigate to="/inicio/calendario" replace />
    },
    {
      path: 'dashboard',
      element: <DashboardPage />
    },
    {
      path: 'dashboard/default',
      element: <DashboardDefault />
    },
    {
      path: 'inicio',
      children: [
        {
          path: 'atendimentos',
          element: <AppointmentsPage />
        },
        {
          path: 'calendario',
          element: <CalendarPage />
        }
      ]
    },
    {
      path: 'financeiro',
      element: <FinancialPage />
    },
    {
      path: 'livro-caixa',
      element: <LivroCaixaPage />
    },
    {
      path: 'compras',
      element: <ComprasPage />
    },
    {
      path: 'simulador',
      element: <SimuladorPage />
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'intellivitta',
      children: [
        {
          path: 'agendamentos',
          element: <AgendamentosPage />
        },
        {
          path: 'mapa-corporal',
          element: <BodyMapPage />
        }
      ]
    },
    {
      path: 'cadastros',
      children: [
        {
          path: 'anamnese',
          element: <AnamnesisPage />
        },
        {
          path: 'pacientes',
          element: <PatientsPage />
        },
        {
          path: 'pacientes/:id',
          element: <PatientDetailPage />
        },
        {
          path: 'aniversariantes',
          element: <BirthdaysPage />
        },
        {
          path: 'profissionais',
          element: <ProfessionalsPage />
        },
        {
          path: 'procedimentos',
          element: <ProceduresPage />
        },
        {
          path: 'planos',
          element: <PlansPage />
        },
        {
          path: 'precificacao',
          element: <PricingPage />
        },
        {
          path: 'mensageria',
          element: <MensageriaPage />
        }
      ]
    }
  ]
};

export default MainRoutes;
